import styled from 'styled-components';

import { colors } from '@ovpn-ui/styles';

export const Wrapper = styled.span`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 21px;
`;

export const Dot = styled.span<{ $new?: boolean }>`
    flex: 0 0 auto;
    align-self: center;
    width: 12px;
    height: 12px;
    margin-right: 8px;

    background-color: ${t => (t.$new ? colors.green : colors.dustyOrange)};
    border-radius: 100%;
    opacity: 1;

    transition: opacity 80ms ease;

    .sidebar-flyout & {
        opacity: 0;
    }

    .ovpn-sidebar-link.expanded & {
        opacity: 0;
    }
`;
